import Axios from "axios";
import { tallyStaticRepAxios , tallyCrudRepAxios } from "src/config/axios.config";
import {
    GET_CASH_PAYMENTS,
    GET_CASH_PAYMENTS_SUCCESS,
    GET_CASH_PAYMENTS_FAILURE,
    CREATE_PAYMENT_SUCCESS,
    CREATE_PAYMENT,
    CREATE_PAYMENT_FAILURE,
    GET_PAYMENT_MADE_FROM_LEDGER_LIST_SUCCESS,
    GET_PAYMENT_MADE_FROM_LEDGER_LIST,
    GET_PAYMENT_MADE_FROM_LEDGER_LIST_FAILURE,
    GET_PAYMENT_MADE_TO_LEDGER_LIST,
    GET_PAYMENT_MADE_TO_LEDGER_LIST_SUCCESS,
    GET_PAYMENT_MADE_TO_LEDGER_LIST_FAILURE,
    GET_BILL_REF_NO,
    GET_BILL_REF_NO_SUCCESS,
    GET_BILL_REF_NO_FAILURE,
    GET_AMOUNT_BY_REF_NO,
GET_AMOUNT_BY_REF_NO_SUCCESS,
GET_AMOUNT_BY_REF_NO_FAILURE,
GET_LEDGER_LIST_FOR_DOUBLE_ENTRY,
GET_LEDGER_LIST_FOR_DOUBLE_ENTRY_SUCCESS,
GET_LEDGER_LIST_FOR_DOUBLE_ENTRY_FAILURE,
CHEK_DUPLICATE_BILL_REF_NO,
CHEK_DUPLICATE_BILL_REF_NO_FAILURE,
CHEK_DUPLICATE_BILL_REF_NO_SUCCESS,
CREATE_PURCHASE,
CREATE_PURCHASE_SUCCESS,
CREATE_PURCHASE_FAILURE,
CREATE_SALE,
CREATE_SALE_SUCCESS,
CREATE_SALE_FAILURE,
GET_PURCHASE_AS_VOUCHER_DATA,
GET_PURCHASE_AS_VOUCHER_DATA_SUCCESS,
GET_PURCHASE_AS_VOUCHER_DATA_FAILURE
} from "../actionTypes";

const getCashPaymentsByAmounts = (amount,type,questionType,fromDate, toDate, transactionType,groupName) => (dispatch) => {

  dispatch({
    type: GET_CASH_PAYMENTS,
  });

  return tallyStaticRepAxios.get(`ledgers/getAllCashPaymentsLedgerTransactionDetails?amount=${amount}&condType=${type}&questionType=${questionType}&fromDate=${fromDate}&toDate=${toDate}&transactionType=${transactionType}&groupName=${groupName}`).then(
    (res) =>
      dispatch({
        type: GET_CASH_PAYMENTS_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_CASH_PAYMENTS_FAILURE,
        payload: err,
      })
  );
};

const createPayment = (data) => (dispatch) => {
  dispatch({
    type: CREATE_PAYMENT,
  });

  return tallyCrudRepAxios.post(`tally/vouchers/saveDetailsByVoucherType`, data).then(
    (res) =>
      dispatch({
        type: CREATE_PAYMENT_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: CREATE_PAYMENT_FAILURE,
        payload: err,
      })
  );
};


const createPurchase = (data) => (dispatch) => {
  dispatch({
    type: CREATE_PURCHASE,
  });

  return tallyCrudRepAxios.post(`tally/vouchers/saveAccountingInvoiceVoucherPurchaseDetails`, data).then(
    (res) =>
      dispatch({
        type: CREATE_PURCHASE_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: CREATE_PURCHASE_FAILURE,
        payload: err,
      })
  );
};

const createSaleAccountingInvoice = (data) => (dispatch) => {
  dispatch({
    type: CREATE_SALE,
  });

  return tallyCrudRepAxios.post(`tally/vouchers/saveAccountingInvoiceVoucherSalesDetails`, data).then(
    (res) =>
      dispatch({
        type: CREATE_SALE_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: CREATE_SALE_FAILURE,
        payload: err,
      })
  );
};

const createSaleAsVoucher = (data) => (dispatch) => {
  dispatch({
    type: CREATE_SALE,
  });

  return tallyCrudRepAxios.post(`tally/vouchers/saveAsVocherModeSalesDetails`, data).then(
    (res) =>
      dispatch({
        type: CREATE_SALE_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: CREATE_SALE_FAILURE,
        payload: err,
      })
  );
};

const createPurchaseAsVoucher = (data) => (dispatch) => {
  dispatch({
    type: CREATE_PURCHASE,
  });

  return tallyCrudRepAxios.post(`tally/vouchers/saveAsVocherModePurchasetDetails`, data).then(
    (res) =>
      dispatch({
        type: CREATE_PURCHASE_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: CREATE_PURCHASE_FAILURE,
        payload: err,
      })
  );
};

const viewPurchaseAsVoucherData = (id) => (dispatch) => {
  dispatch({
    type: GET_PURCHASE_AS_VOUCHER_DATA,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getVoucherPurchaseAndSalesAsVoucherDetailsByid?id=${id}`).then(
    (res) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_FAILURE,
        payload: err,
      })
  );
};

const viewPurchaseAccountingInvoice = (id) => (dispatch) => {
  dispatch({
    type: GET_PURCHASE_AS_VOUCHER_DATA,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getVoucherPurchaseAndSalesAccountingDetailsByid?id=${id}`).then(
    (res) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_FAILURE,
        payload: err,
      })
  );
};

const viewPurchaseOrSalesAccountingInvoice = (id) => (dispatch) => {
  dispatch({
    type: GET_PURCHASE_AS_VOUCHER_DATA,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getAccountingInvoiceDetailsOfPurchaseAndSalesByid?id=${id}`).then(
    (res) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_FAILURE,
        payload: err,
      })
  );
};

const viewPurchaseOrSalesAsVoucherData = (id) => (dispatch) => {
  dispatch({
    type: GET_PURCHASE_AS_VOUCHER_DATA,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getAsVoucherOfPurchaseAndSalesDetailsByid?id=${id}`).then(
    (res) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_PURCHASE_AS_VOUCHER_DATA_FAILURE,
        payload: err,
      })
  );
};

const getPamentFromLedgerList = () => (dispatch) => {
  dispatch({
    type: GET_PAYMENT_MADE_FROM_LEDGER_LIST,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getPaymentMadeLedgersList`).then(
    (res) =>
      dispatch({
        type: GET_PAYMENT_MADE_FROM_LEDGER_LIST_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_PAYMENT_MADE_FROM_LEDGER_LIST_FAILURE,
        payload: err,
      })
  );
};

const getPamentToLedgerList = () => (dispatch) => {
  dispatch({
    type: GET_PAYMENT_MADE_TO_LEDGER_LIST,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getAllLedgerNamesForPaymentVoucherType`).then(
    (res) =>
      dispatch({
        type: GET_PAYMENT_MADE_TO_LEDGER_LIST_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_PAYMENT_MADE_TO_LEDGER_LIST_FAILURE,
        payload: err,
      })
  );
};

const getBillRefByLedgerId = (id,refType) => (dispatch) => {
  dispatch({
    type: GET_BILL_REF_NO,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getVoucherTypeBillRefNosByLedgerId?ledgerId=${id}&refType=${refType}`).then(
    (res) =>
      dispatch({
        type: GET_BILL_REF_NO_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_BILL_REF_NO_FAILURE,
        payload: err,
      })
  );
};


const getAmountsByBillRef = () => (dispatch) => {
  dispatch({
    type: GET_AMOUNT_BY_REF_NO,
  });

  return tallyCrudRepAxios.get(`tally/vouchers/getPaymentAmountAndTypeByBillRefNo?billRefNo=SP-0009`).then(
    (res) =>
      dispatch({
        type: GET_AMOUNT_BY_REF_NO_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_AMOUNT_BY_REF_NO_FAILURE,
        payload: err,
      })
  );
};

const getDoubleEntryPaymentLedgerList = () => (dispatch) => {
  dispatch({
    type: GET_LEDGER_LIST_FOR_DOUBLE_ENTRY,
  });
  return tallyCrudRepAxios.get(`tally/vouchers/getAllLedgerNamesForDoubleEntryPaymentVoucherType`).then(
    (res) =>
      dispatch({
        type: GET_LEDGER_LIST_FOR_DOUBLE_ENTRY_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_LEDGER_LIST_FOR_DOUBLE_ENTRY_FAILURE,
        payload: err,
      })
  );
};


const checkDupilcateBillRefNo = (refNo,id) => (dispatch) => {
  dispatch({
    type: CHEK_DUPLICATE_BILL_REF_NO,
  });
  return tallyCrudRepAxios.get(`tally/vouchers/checkNewRefNoAlreadyExist?refNo=${refNo}&ledgerId=${id}`).then(
    (res) =>
      dispatch({
        type: CHEK_DUPLICATE_BILL_REF_NO_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: CHEK_DUPLICATE_BILL_REF_NO_FAILURE,
        payload: err,
      })
  );
};

export {
   getCashPaymentsByAmounts, 
   createPayment ,
   getPamentFromLedgerList, 
   getPamentToLedgerList, 
   getAmountsByBillRef, 
   getBillRefByLedgerId, 
   getDoubleEntryPaymentLedgerList ,
   checkDupilcateBillRefNo ,
   createPurchase,
   createPurchaseAsVoucher,
   createSaleAccountingInvoice,
   createSaleAsVoucher,
   viewPurchaseAsVoucherData,
   viewPurchaseAccountingInvoice,
   viewPurchaseOrSalesAccountingInvoice,
   viewPurchaseOrSalesAsVoucherData
  };
